var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.666 1.667h2L5 .333h4l1.333 1.334h2A1.333 1.333 0 0113.666 3v8a1.333 1.333 0 01-1.333 1.333H1.666A1.333 1.333 0 01.333 11V3a1.333 1.333 0 011.333-1.333zm5.334 2a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zM7 5a2 2 0 110 4 2 2 0 010-4z",
    fill: "#343434"
  })));
}
export default SvgCamera;